import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class LocalService {

    public sidebarEventSource = new BehaviorSubject<boolean>(false);

    constructor(private storageService: StorageService) { }

    open() {
        this.sidebarEventSource.next(true);
    }

    set(key: string, value: any) {
        this.storageService.setItem(this.storageService.hash(key), value);
    }

    get<T = any>(key: string) {
        return this.storageService.getItem<T>(this.storageService.hash(key));
    }

    remove(key: string) {
        return this.storageService.removeItem(this.storageService.hash(key));
    }

    clearStorage() {
        this.storageService.clear();
    }
}
